import axiosClient from "./axiosClient";

class IpSetting {
    constructor() {
        this.api_url = "/api/ip-setting";
    }

    async getAll(credentials) {
        return await axiosClient.get(this.api_url, {
            params: {
                page: credentials.page,
                type: credentials.type,
                perPage: credentials.perPage,
                search: credentials.search,
            },
        });
    }

    async delete(credentials) {
        const res = await axiosClient.post(this.api_url + "/delete", credentials );
        return res;
    }

    async createIP(credentials) {
        const res = await axiosClient.post(this.api_url, credentials);
        return res;
    }

    async changeStatus(credentials) {
        const res = await axiosClient.post(this.api_url + "/update-status", credentials );
        return res;
    }
}

export default new IpSetting;